// extracted by mini-css-extract-plugin
module.exports = {"container":"intro-module--container--a0aQL layout--module--3QxU_","left":"intro-module--left--2p7lc","right":"intro-module--right--2S9mP"};